import { MenuItemProps, SelectProps } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

export const renderMultipleValue = <T,>(
  placeholder: SelectProps['placeholder'],
  menuItems: ReactElement<MenuItemProps>[],
) => {
  const labels = menuItems.reduce<Partial<Record<string, ReactNode>>>((acc, item) => {
    const { value, children: itemChildren = value } = item.props;
    let label = itemChildren;
    if (Array.isArray(itemChildren)) {
      label = itemChildren[itemChildren.length - 1];
    }
    if (label) {
      return { ...acc, [value as string]: label };
    }
    return acc;
  }, {});

  return (value: T | T[]): ReactNode => {
    const current = value as T[];
    if (!current || current.length === 0) {
      return <span className="Mui-placeholder">{placeholder}</span>;
    }
    return current.map(v => labels[v as string]).join(', ');
  };
};

export const MenuSxPropMedium = {
  '& .MuiMenuItem-root': {
    fontSize: '14px',
    height: '44px',
  },
};
export const MenuSxPropSmall = {
  '& .MuiMenuItem-root': {
    fontSize: '11px',
    height: '31px',
  },
};

export const selectBoxStyles = {
  '& .MuiListItemText-secondary': {
    display: 'none',
  },
};
